import { render, staticRenderFns } from "./elo.vue?vue&type=template&id=7038846c&scoped=true"
import script from "./elo.vue?vue&type=script&lang=js"
export * from "./elo.vue?vue&type=script&lang=js"
import style0 from "./elo.vue?vue&type=style&index=0&id=7038846c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038846c",
  null
  
)

export default component.exports